import axios from "axios";
import storePersist from "./../redux/storePersist";
import errorHandler from "../request/errorHandler";
import successHandler from "../request/successHandler";
import getRequestURl from "../request/requester";
var querystring = require("querystring");
const baseUrlIAM = process.env.REACT_APP_API_URL;
export const fetchGuestToken = async ({ loginData }) => {    
  try {
    const response = await axios.post(
      `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/token-service/guest-token`,
      loginData,
      {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      }
    );
    const { status } = await response;
    const resp = await response;
    const data = {
      success: true,
      result: resp.data,
    };
    storePersist.set("tokenData", {
      current: data,
      isLoading: false,
      isSuccess: true,
    });
    successHandler(
      { data, status },
      {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      }
    );
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const generateLoginPin = async ({ loginData }) => {
  const guest = localStorage.getItem("guest-token");

  try {
    const response = await axios.post(
      `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/token-service/generate-login-pin`,
      loginData,
      {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + guest,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      }
    );
    const { status } = await response;

    const resp = await response;
    console.log('generate pin resp', resp)
    const data = {
      success: true,
      result: resp.data,
    };
    // storePersist.set("accessToken", {
    //   current: data.result,
    //   isLoading: false,
    //   isSuccess: true,
    // });
    successHandler(
      { data, status },
      {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      }
    );
    return data;
  } catch (error) {
    return errorHandler(error, false);
  }
};

export const requestOtp = async ({ loginData }) => {
  const guest = localStorage.getItem("guest-token");


  try {
    const response = await axios.post(
      `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/token-service/send-login-otp`,
      loginData,
      {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + guest,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      }
    );
    const { status } = await response;

    const resp = await response;
    const data = {
      success: true,
      result: resp.data,
    };
    storePersist.set("accessToken", {
      current: data.result,
      isLoading: false,
      isSuccess: true,
    });
    successHandler(
      { data, status },
      {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      }
    );
    return data;
  } catch (error) {
    return errorHandler(error, false);
  }
};

export const login = async ({ loginData }) => {
  console.log(loginData);
  const guest = localStorage.getItem("guest-token");

  try {
    const response = await axios.post(
      `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/token-service/login`,
      loginData,
      {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + guest,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      }
    );
    const { status } = await response;

    const resp = await response;
    const data = {
      success: true,
      result: resp.data,
    };
    storePersist.set("accessToken", {
      current: data.result,
      isLoading: false,
      isSuccess: true,
    });
    successHandler(
      { data, status },
      {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      }
    );
    return data;
  } catch (error) {
    return errorHandler(error, false);
  }
};

export const loginWithPin = async ({ loginData }) => {
  const guest = localStorage.getItem("guest-token");
  try {
    const response = await axios.post(
      `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/token-service/login-with-pin`,
      loginData,
      {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + guest,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      }
    );
    const { status } = await response;

    const resp = await response;
    const data = {
      success: true,
      result: resp.data,
    };
    storePersist.set("accessToken", {
      current: data.result,
      isLoading: false,
      isSuccess: true,
    });
    successHandler(
      { data, status },
      {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      }
    );
    return data;
  } catch (error) {
    return errorHandler(error, false);
  }
};

export const forgotPassword = async ({ loginData }) => {
  const guest = localStorage.getItem("guest-token");
  try {
    const response = await axios.post(
      `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/iam/token-service/send-reset-password-otp`,
      loginData,
      {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + guest,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      }
    );
    const { status } = await response;

    const resp = await response;
    const data = {
      success: true,
      result: resp.data,
    };
    storePersist.set("accessToken", {
      current: data.result,
      isLoading: false,
      isSuccess: true,
    });
    successHandler(
      { data, status },
      {
        notifyOnSuccess: true,
        notifyOnFailed: false,
      }
    );
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const resetPassword = async ({ loginData }) => {
  const guest = localStorage.getItem("guest-token");
  try {
    const response = await axios.post(
      `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/iam/token-service/reset-password`,
      loginData,
      {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + guest,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      }
    );
    const { status } = await response;

    const resp = await response;
    const data = {
      success: true,
      result: resp.data,
    };
    storePersist.set("accessToken", {
      current: data.result,
      isLoading: false,
      isSuccess: true,
    });
    successHandler(
      { data, status },
      {
        notifyOnSuccess: true,
        notifyOnFailed: false,
      }
    );
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const logout = async () => {
  try {
    window.localStorage.clear();
  } catch (error) {
    return errorHandler(error);
  }
};

// siva.t@digiit.biz
// Siva@Pay@22
